<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <div class="fix-header-section">
    <div class="header-middle-gap"></div>
    <div class="header-right">
      <div class="actions" v-if="menu_store.is_visible">
        <div class="link-group">
          <a-dropdown placement="bottom">
            <div class="user-org-container">
              <span class="user-org">
                <div class="user-name">
                  {{ user_store.auth.user?.nick_name }}
                </div>
                <div class="org-name">{{ user_store.auth.organization?.display_name }}</div>
              </span>
              <span class="avatar">
                <avatar></avatar>
              </span>
            </div>
            <template #overlay>
              <a-menu
                class="menu"
                :items="profile_menu_items"
                v-model:selectedKeys="select_theme_key"
              />
            </template>
          </a-dropdown>
        </div>
      </div>
      <a-dropdown v-else>
        <a-avatar
          class="avatar-large"
          size="large"
          :src="`https://www.gravatar.com/avatar/${Crypto.hash_sha256(user_store.auth.user?.email)}`"
        />
        <template #overlay>
          <a-menu
            v-if="settingsStore.settings.device === 'mobile'"
            :class="['avatar-menu']"
            :items="menu_items"
            v-model:selectedKeys="select_menu_keys"
          >
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>
<script setup lang="tsx">
import { useMenuStore } from '@/stores/menu'
import { h, ref } from 'vue'
import { useSettingsStore, type AvailableThemes } from '@/stores/settings'
import { Crypto } from '@/libs/utils/hash'
import router from '@/router'
import { useIdentityStore } from '@/stores/identity/auth'

const user_store = useIdentityStore()
const settingsStore = useSettingsStore()
const menu_store = useMenuStore()
const documentationURL = ref('')

const avatar = () => (
  <div class={'avatar-inner'}>
    <a-avatar
      class="avatar-small"
      size="medium"
      src={`https://www.gravatar.com/avatar/${Crypto.hash_sha256(user_store.auth.user?.email)}`}
    />
  </div>
)
type MenuOption = {
  label: string
  key?: string
  icon?: any
  onclick?: any
  children?: any[]
}
function make_menu_item({
  label,
  key = label,
  icon,
  onclick,
  children,
}: MenuOption) {
  return {
    key,
    icon,
    label,
    theme: settingsStore.settings.theme,
    children,
    onclick,
  }
}
const theme_options = [
  make_menu_item({
    label: 'Light',
    onclick: () => setTheme('Light'),
  }),
  make_menu_item({
    label: 'Dark',
    onclick: () => setTheme('Dark'),
  }),
  make_menu_item({
    label: 'System',
    onclick: () => setTheme('System'),
  }),
]
const profile_menu_items = [
  make_menu_item({
    children: [...theme_options],
    label: 'Theme',
  }),
  // make_menu_item({
  //   label: 'Switch Organization',
  //   onclick: () => router.push('/switch-org'),
  // }),
  make_menu_item({
    label: 'Settings',
    onclick: () => router.push('/settings'),
  }),
  make_menu_item({
    label: 'Sign out',
    onclick: () => router.push('/logout'),
  }),
]
const select_theme_key = ref([settingsStore.settings.theme])
const select_menu_keys = ref([])
const menu_items = [
  make_menu_item({ label: 'Documentation', onclick: openDocs }),
  make_menu_item({ label: 'Report Bug', onclick: report_bug }),
  ...profile_menu_items,
]

function openHelp() {
  window.dispatchEvent(new Event('show_intro'))
}
function openDocs() {
  window.open(documentationURL.value)
}
function report_bug(event: Event) {
  event.preventDefault()
}
function setTheme(value: AvailableThemes) {
  select_theme_key.value = [value]
  settingsStore.setTheme(value)
}
</script>
<style scoped>
.icon-text {
  font-size: 14px;
}

.icon-btn {
  margin-right: 12px;
}

.icon-btn:first-child {
  margin-left: 2px;
}

.svg-icon {
  height: 22px;
  margin-top: 3px;
}

.fix-header-section {
  position: relative;
  z-index: 1;
  right: 0px;
  padding: 5px;
  width: 100%;
  display: inline-flex;
  height: 56px;
}

.search {
  width: 400px;
}

.header-middle-gap {
  width: 100%;
}

.action-items {
  display: inline-flex;
  margin-left: 20px;
}

.header-right {
  position: relative;
  right: 0;
}

.actions {
  width: fit-content;
  height: 46px;
  right: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.link-group {
  width: fit-content;
  height: 46px;
  right: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu {
  width: 200px;
}
.avatar-large {
  margin: 10px;
}

.icon-select {
  width: 60px;
}

.user-org-container {
  padding: 15px 0 0 5px;
  display: flex;
  flex-direction: row;
}
.avatar {
  padding: 0 5px;
}
.avatar-inner {
  cursor: pointer;
  padding: 4px;
  display: flex;
  position: relative;
  top: 14px;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  transition: background-color 300ms;
}
.avatar-inner:hover {
  background-color: var(--color-background-hover);
}
.user-org {
  display: flex;
  padding: 14px 0;
  flex-direction: column;
  align-items: end;
}
.user-name {
  display: flex;
  height: 19px;
  line-height: 19px;
  width: fit-content;
  white-space: nowrap;
  text-align: right;
}
.org-name {
  display: flex;
  height: 19px;
  line-height: 19px;
  width: fit-content;
  white-space: nowrap;
  text-align: right;
}
</style>
